import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon'

Vue.component(FeatherIcon.name, FeatherIcon)
